import { render } from "./Publication.vue?vue&type=template&id=cc6e9ee4"
import script from "./Publication.vue?vue&type=script&lang=ts"
export * from "./Publication.vue?vue&type=script&lang=ts"

import "./Publication.vue?vue&type=style&index=0&id=cc6e9ee4&rel=stylesheet&lang=scss"
script.render = render

export default script